import testsQuestions, {
  TestQuestionsListParams
} from "@/getinfo-api/test-questions";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import { uniqBy } from "lodash";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export default {
  namespaced: true,
  state: {
    copiedQuestions: [],
    copyTests: []
  },
  actions: {
    async GET_QUESTIONS_BY_TEST(ctx: any, params: TestQuestionsListParams) {
      let currentOffset = 0;
      let currentQuestions: ITestQuestion[] = [];

      const getTestQuest = async (params: TestQuestionsListParams) => {
        try {
          let { data } = await testsQuestions(params);
          currentQuestions = [...currentQuestions, ...data.questions];

          if (currentQuestions.length < data.count) {
            currentOffset = currentOffset + (params.limit ?? 500);
            await getTestQuest({ ...params, offset: currentOffset });
          }
        } catch (e) {
          throw Error(e);
        }
      };

      try {
        await getTestQuest(params);

        ctx.commit("ADD_TESTS_QUESTIONS", currentQuestions);

        ctx.dispatch(
          "successToast",
          {
            message: `
            ${i18n.tc(LocalesFields.CopiedQuestions)}: ${
              currentQuestions?.length
            }`
          },
          { root: true }
        );
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    }
  },
  mutations: {
    ADD_TESTS_QUESTIONS(state: any, questions: Array<ITestQuestion>) {
      state.copiedQuestions = [...state.copiedQuestions, ...questions];
      state.copiedQuestions = uniqBy(state.copiedQuestions, "id");
    },
    DELETE_QUESTION(state: any, questionId: string) {
      state.copiedQuestions = state.copiedQuestions.filter(
        (el: ITestQuestion) => el.id !== questionId
      );
    },
    DELETE_ALL_QUESTIONS(state: any) {
      state.copiedQuestions = [];
    }
  },
  getters: {
    GET_QUESTIONS(state: any) {
      return state.copiedQuestions;
    }
  }
};
